import _ from 'lodash';
import { Download, AddToCollections, SharePopup } from '../common';
import {
  EDIT_ICON,
  SHARE_ICON,
  DELETE_ICON,
  COLLECTION_ICON,
  DOWNLOAD_ICON,
  ARCHIVE,
} from '../constants/assetConstants';
import {
  Filter_By_Value,
  Filter_By_Label,
  Sort_By_Value,
  Sort_By_Label,
  Room_Template_Label,
  Lifestyle_Label,
  Silo_Label,
  Vignette_Label,
  Web_Viewer_360_Label,
  Video_Label,
  Configurator_Label,
  Augmented_Reality_Label,
  Recent_First_Value,
  Oldest_First_Value,
  A_Z_Value,
  Z_A_Value,
  Recent_First_Label,
  Oldest_First_Label,
  A_Z_Label,
  Z_A_Label,
  My_Projects_Label,
  My_Projects_Value,
  Previews_Label,
  Previews_Value,
  Renders_Label,
  Renders_Value,
  Models_3d_Label,
  Models_3d_Value,
  Uploads_Label,
  Uploads_Value,
  Collections_Label,
  Collections_Value,
  Textures_Label,
  Textures_Value,
  Props_Label,
  Props_Value,
  Templates_Label,
  Templates_Value,
  Rooms_Label,
  Rooms_Value,
  Requests_Value,
  Requests_Label,
  Shared_Files_Value,
  Shared_Files_Label,
  With_Me_Label,
  With_Organisation_Label,
  By_Me_Label,
  With_Me_Value,
  With_Organisation_Value,
  By_Me_Value,
  Notification_Recent_First_Value,
  Notification_Oldest_First_Value,
  Notification_A_Z_Value,
  Notification_Z_A_Value,
  Notification_From_LF,
  By_Team_Member_Label,
  With_Team_Member_Label,
  With_Team_Member_Value,
  By_Team_Member_Value,
  Notification_LOA,
  Recent_First_Value_Created_At,
  Oldest_First_Value_Created_At,
  AUTOMATION_LABEL,
  AUTOMATION_VALUE,
  threeDModelsValue,
  threeDModelsLabel,
  creativeServiceLabel,
  creativeServiceValue,
  customServiceLabel,
  customServiceValue,
  SeamlessTextureValue,
  SeamlessTextureLabel,
  Configurator_Value,
  Video_Value,
  Shared_Files_Recent_First_Value,
  Shared_Files_Oldest_First_Value,
  RequestConfiguratorValue,
  RequestVideoValue,
  imagesLable,
  threeDFilesLable,
  documentsLable,
  documentsValue,
  threeDFilesValue,
  imagesValue,
  recentLable,
  nameLable,
  sizeLable,
  kindLable,
  recentValue,
  nameValue,
  sizeValue,
  kindValue,
  CONFIGURATOR_LABEL,
  PRODUCT_CONFIGURATOR_LABEL,
  IMAGINE_AI_LABEL,
  Sequence_Number,
  Sequence_Number_Label,
  MATERIALS_SAVE_LABEL,
} from '../constants/filters';
import {
  CARD_TYPE,
  MODEL_TYPES,
  MODULE_TYPE_OPTIONS,
  NOTIFICATION_MODEL_TYPE,
  RENDER_STATUS,
  TRASH_MODEL_TYPE,
} from '../constants/constants';
import { useRoomTypeOptions } from '../hooks/useRoomTypes';
import { ROOM_TYPE } from '../constants/projectConstants';
import {
  COLLECTION_DETAILS_API,
  GET_PROJECT_API,
  ROOM_DETAILS_API,
  TEXTURE_DETAILS_API,
} from '../config/constant/apiConstant';
import { useUserContext } from '../contexts/UserContext';
import {
  STATUS_CLOSED_LABEL,
  STATUS_CLOSED_VALUE,
  STATUS_OPEN_LABEL,
  STATUS_OPEN_VALUE,
} from '../constants/supportConstants';
import { useSearchParams } from 'react-router-dom';
import { CONFIGURATOR_TYPE } from '../constants/productConfiguratorConstants';
import { PERMISSIONS } from '../constants/permissionConstants.js';

// Filter Options
const filterByOption = { label: Filter_By_Label, value: Filter_By_Value };
const noneOption = { label: 'None', value: '' };
const allOptions = { label: 'Select All', value: '' };
const createdFromApp = { label: 'Created from App', key: 'is_custom', apiValue: true, value: '-1' };
// const inspirationSort = { label: 'Inspirations', key: 'is_inspiration', apiValue: true, value: '-1' };
const projectAutosaveFilter = { label: 'Autosave', key: 'is_autosave', apiValue: true, value: 'autosave' };
export const productConfigurator360 = { label: '360', value: CONFIGURATOR_TYPE.THREE_SIXTY };
export const productConfigurator = { label: 'Image', value: CONFIGURATOR_TYPE.IMAGE };
export const threeDViewer = { label: '3D Object', value: CONFIGURATOR_TYPE.THREED_VIEWER };
export const uploadImage = { label: 'Image Detail', value: CONFIGURATOR_TYPE.UPLOAD_IMAGE };
const inspirationSort = { label: 'Inspirations', value: '-inspiration' };
const roomFilter = { label: Room_Template_Label, value: ROOM_TYPE.ROOM };
const lifestyleFilter = {
  label: Lifestyle_Label,
  value: ROOM_TYPE.LIFESTYLE,
};
const siloFilter = { label: Silo_Label, value: ROOM_TYPE.SILO };
const vignetteFilter = { label: Vignette_Label, value: ROOM_TYPE.VIGNETTE };
const threeSixtyFilter = {
  label: Web_Viewer_360_Label,
  value: ROOM_TYPE.THREESIXTY,
};
const videoFilter = { label: Video_Label, value: ROOM_TYPE.VIDEO };
const configuratorFilter = {
  label: Configurator_Label,
  value: ROOM_TYPE.CONFIGURATOR,
};
const myProjectsFilter = { label: My_Projects_Label, value: MODULE_TYPE_OPTIONS.PROJECT };
export const previewsFilter = {
  label: 'Non commercial', // Previews_Label,
  key: 'is_paid_license',
  apiValue: false,
  value: MODULE_TYPE_OPTIONS.PREVIEWS,
};
export const rendersFilter = {
  label: 'Premium', //Renders_Label,
  key: 'is_paid_license',
  apiValue: true,
  value: MODULE_TYPE_OPTIONS.RENDERS,
};
const collectionPreviewsFilter = { label: Previews_Label, value: MODULE_TYPE_OPTIONS.PREVIEWS };
const collectionRendersFilter = { label: Renders_Label, value: MODULE_TYPE_OPTIONS.RENDERS };
const models3DFilter = { label: Models_3d_Label, value: MODULE_TYPE_OPTIONS.THREEDMODELS };
const uploadsFilter = {
  label: 'Uploads',
  key: 'is_upload',
  apiValue: true,
  value: MODULE_TYPE_OPTIONS.UPLOADS,
};
const collectionUploadsFilter = { label: Uploads_Label, value: MODULE_TYPE_OPTIONS.UPLOADS };
const collectionsFilter = {
  label: Collections_Label,
  value: Collections_Value,
};
const texturesFilter = { label: Textures_Label, value: MODULE_TYPE_OPTIONS.TEXTURES };
const propsFilter = { label: Props_Label, value: MODULE_TYPE_OPTIONS.PROPS };
const templatesFilter = { label: Templates_Label, value: MODULE_TYPE_OPTIONS.TEMPLATES };
const roomsFilter = { label: Rooms_Label, value: MODULE_TYPE_OPTIONS.ROOMS };
const requestsFilter = { label: Requests_Label, value: Requests_Value };
const shareFilesFilter = {
  label: Shared_Files_Label,
  value: Shared_Files_Value,
};
const materialFilter = { label: Rooms_Label, value: MODULE_TYPE_OPTIONS.MATERIAL }; // TODO
const servicesFilter = { label: Rooms_Label, value: Rooms_Value }; // TODO
const newFeatureFilter = { label: Rooms_Label, value: Rooms_Value }; // TODO
const fromLiveFurnishFilter = { label: Rooms_Label, value: Rooms_Value }; // TODO
const archivedFilter = { label: 'Archived', value: 'ARCHIVED', key: 'is_archived', apiValue: true };
const createdFromAppFilter = { label: Rooms_Label, value: Rooms_Value }; // TODO
const auotmationFilter = { label: AUTOMATION_LABEL, value: MODULE_TYPE_OPTIONS.AUTOMATION }; // TODO
const colletionsConfiguratorFilter = { label: CONFIGURATOR_LABEL, value: MODULE_TYPE_OPTIONS.PRODUCT_CONFIGURTOR }; // TODO
const savedMaterialsFilter = { label: MATERIALS_SAVE_LABEL, value: MODULE_TYPE_OPTIONS.MATERIAL }; // TODO

// sort Options
const SortByOption = { label: Sort_By_Label, value: Sort_By_Value };
export const SortRecentFirst = {
  label: Recent_First_Label,
  value: Recent_First_Value,
};
export const tutorialsSortRecentFirst = {
  label: Recent_First_Label,
  value: Sequence_Number,
};
export const tutorialsSortSequenceNumber = {
  label: Sequence_Number_Label,
  value: Sequence_Number,
};
export const sharedFilesSortRecentFirst = {
  label: Recent_First_Label,
  value: Shared_Files_Recent_First_Value,
};
const SortOldestFirst = {
  label: Oldest_First_Label,
  value: Oldest_First_Value,
};
const SharedFilesSortOldestFirst = {
  label: Oldest_First_Label,
  value: Shared_Files_Oldest_First_Value,
};
export const SortRecentFirstCreatedAt = {
  label: Recent_First_Label,
  value: Recent_First_Value_Created_At,
};
const SortOldestFirstCreatedAt = {
  label: Oldest_First_Label,
  value: Oldest_First_Value_Created_At,
};
const SortAZ = { label: A_Z_Label, value: A_Z_Value };
const SortZA = { label: Z_A_Label, value: Z_A_Value };
const NotificationSortRecentFirst = {
  label: Recent_First_Label,
  value: Notification_Recent_First_Value,
};
const NotificationSortOldestFirst = {
  label: Oldest_First_Label,
  value: Notification_Oldest_First_Value,
};

const TextureFilterOption = {
  label: "Textures",
  value: "texturesv3",
};
const ModelFilterOption = {
  label: "Models",
  value: "productv3",
};

const ProjectFilterOption = {
  label: "Projects",
  value: "project",
};
const NotificationSortAZ = { label: A_Z_Label, value: Notification_A_Z_Value };
const NotificationSortZA = { label: Z_A_Label, value: Notification_Z_A_Value };
const IncompleteFirst = { label: Z_A_Label, value: Z_A_Value }; // TODO
const GroupedSort = { label: Rooms_Label, value: Rooms_Value }; // TODO
const UngroupedSort = { label: Rooms_Label, value: Rooms_Value }; // TODO
const sharedWithMe = { label: With_Me_Label, value: With_Me_Value };
const sharedWithOrganization = { label: With_Organisation_Label, value: With_Organisation_Value };
export const sharedWithTeam = { label: With_Team_Member_Label, value: With_Team_Member_Value };
export const sharedByTeam = { label: By_Team_Member_Label, value: By_Team_Member_Value };

export const sharedByMe = { label: By_Me_Label, value: By_Me_Value };

const COMMON_FILTERS = [filterByOption, roomFilter, lifestyleFilter, vignetteFilter, siloFilter];

const nFilterRender = { label: Renders_Label, value: NOTIFICATION_MODEL_TYPE.RenderStatus };
const nFilterPreview = { label: Previews_Label, value: NOTIFICATION_MODEL_TYPE.Preview };
const nFilterRequest = {
  label: Requests_Label,
  value: NOTIFICATION_MODEL_TYPE.RequestStatusAndComments,
};
const nFilterSharedFiles = {
  label: Shared_Files_Label,
  value: NOTIFICATION_MODEL_TYPE.SharedFiles,
};
// const nFilterLiveFurnish = {
//   label: Notification_From_LF,
//   value: NOTIFICATION_MODEL_TYPE.FromLiveFurnish,
// };
const nFilterLiveOnApp = {
  label: Notification_LOA,
  value: NOTIFICATION_MODEL_TYPE.LiveOnAppRender,
};

export const COMMON_SORT_OPTIONS = [SortRecentFirst, SortOldestFirst, SortAZ, SortZA];
export const SHARED_FILES_SORT_OPTIONS = [sharedFilesSortRecentFirst, SharedFilesSortOldestFirst, SortAZ, SortZA];
export const COMMON_SORT_OPTIONS_WITH_CREATED_AT = [SortRecentFirstCreatedAt, SortOldestFirstCreatedAt, SortAZ, SortZA];
export const ADMIN_SHARED_OPTIONS = [sharedWithTeam]; //, sharedByTeam];
export const COMMON_SHARED_OPTIONS = [sharedWithMe, sharedWithOrganization]; //, sharedByMe];

export const SHARED_OPTIONS_URL_PARAMS = {
 [With_Me_Value]:"with_me", 
 [With_Organisation_Value]:"with_organisation",
 [By_Team_Member_Value]:"with_team",
}

export const CONFIGURATOR_SORT_OPTIONS = [SortRecentFirstCreatedAt, SortOldestFirstCreatedAt];

export const NOTIFICATION_SORT_OPTIONS = [
  NotificationSortRecentFirst,
  NotificationSortOldestFirst,
  NotificationSortAZ,
  NotificationSortZA,
];

export const NOTIFICATION_FILTER_OPTIONS = [
  noneOption,
  nFilterRender,
  nFilterPreview,
  nFilterRequest,
  nFilterSharedFiles,
  // nFilterLiveFurnish,
];

// const tFilterNew = { label: 'New', value: 'new' };
// const tFilterPending = { label: 'Pending', value: 'pending' };
// const tFilterResolved = { label: 'Resolved', value: 'resolved' };
// const tFilterReOpen = { label: 'Re-opened', value: 're-open' };

// export const TICKET_FILTER_OPTIONS = [tFilterNew, tFilterPending, tFilterResolved, tFilterReOpen];

const tFilterAll = { label: 'All', value: '' };
const tFilterOpen = { label: STATUS_OPEN_LABEL, value: STATUS_OPEN_VALUE };
const tFilterClose = { label: STATUS_CLOSED_LABEL, value: STATUS_CLOSED_VALUE };

export const TICKET_FILTER_OPTIONS = [tFilterAll, tFilterOpen, tFilterClose];

// delete the card
// need to refactor api endpoints to be passed dynamically here
const handleCardDelAction = (e, id, endpoint) => {
  e.preventDefault();
  // if (cardType === "rooms") {
  //   // roomDeleteApi(id);
  // } else if (cardType === "projects" || cardType === "props") {
  //   // projectDeleteApi(id);
  // }
};

const onFullScreenClick = () => {};

const SHARED_FILES_FILTER = [
  noneOption,
  { label: Renders_Label, value: MODEL_TYPES.PROJECTRENDER },
  { label: Previews_Label, value: MODEL_TYPES.PREVIEWS },
  { label: My_Projects_Label, value: MODEL_TYPES.PROJECTS },
  { label: Models_3d_Label, value: MODEL_TYPES.THREEDMODELS },
  { label: Rooms_Label, value: MODEL_TYPES.ROOM },
  { label: Textures_Label, value: MODEL_TYPES.TEXTURE },
  { label: Uploads_Label, value: MODEL_TYPES.UPLOADS },
  { label: Collections_Label, value: MODEL_TYPES.COLLECTION },
  { label: Templates_Label, value: MODEL_TYPES.TEMPLATES },
  { label: Props_Label, value: MODEL_TYPES.PRODUCT },
  { label: CONFIGURATOR_LABEL, value: MODEL_TYPES.CONFIGURATOR },
  { label: PRODUCT_CONFIGURATOR_LABEL, value: MODEL_TYPES.PRODUCT_CONFIGURATOR },
];

const COLLECTIONS_FILTER = [
  noneOption,
  // fields below are valid only for collection as collection has different model types
  collectionRendersFilter,
  collectionPreviewsFilter,
  myProjectsFilter,
  models3DFilter,
  roomsFilter,
  texturesFilter,
  collectionUploadsFilter,
  templatesFilter,
  propsFilter,
  auotmationFilter,
  colletionsConfiguratorFilter,
  savedMaterialsFilter,
];

const fromLiveFurnishNFilter = { label: Rooms_Label, value: Rooms_Value }; // TODO
const trashProjectFilter = { label: My_Projects_Label, value: TRASH_MODEL_TYPE.PROJECT };
const trashPreviewFilter = { label: Previews_Label, value: TRASH_MODEL_TYPE.PROJECT_PREVIEW };
const trashTextureFilter = { label: Textures_Label, value: TRASH_MODEL_TYPE.TEXTURE };
const trashCustomMapsFilter = { label: Uploads_Label, value: TRASH_MODEL_TYPE.UPLOADS };
const trashUploadsFilter = { label: "Uploads", value: TRASH_MODEL_TYPE.UPLOADED_RENDER };
const trashCollectionFilter = { label: Collections_Label, value: TRASH_MODEL_TYPE.COLLECTION };
const trashAutomationFilter = { label: AUTOMATION_LABEL, value: TRASH_MODEL_TYPE.AUTOMATION };
const trashConfiguratorFilter = { label: CONFIGURATOR_LABEL, value: TRASH_MODEL_TYPE.CONFIGURATOR };
const trashImagineAIFilter = { label: IMAGINE_AI_LABEL, value: TRASH_MODEL_TYPE.IMAGINE_AI };

const ImagineAiFilterOption = [
  { label: "None", value: "" },
  { label: "Inspiration", value: "inspiration_generation" },
  { label: "Product Background", value: "product_background_generation" },
  { label: "Background Removal", value: "bg_removal" },
  { label: "Silo Studio", value: "imagineaiv2_silogeneration" },
  { label: "HD Scaler", value: "imagineaiv2_upscale" },
  { label: "Lifestyle Studio", value: "imagineaiv2_lifestyle" },
  { label: "Re-stage", value: "imagineaiv2_productswap" },
  { label: "Texture Swap", value: "imagineaiv2_productdrape" },
  { label: "AI Studio BG Removal", value: "imagineaiv2_bgremoval" },
  { label: "My Asset", value: "has_input_image", },
  { label: "All Creations", value: "generated_output" },
]

const ImagineV2Filter = { label: "Imagine 2.0", value: "ai_image_2.0" }

export const useScreenSettings = (cardType) => {
  const { canAccessLiveOnAppData, canAccessLiveOnApp} = useUserContext();
  const isTexture = cardType === 'texture';
  const isProject = cardType === 'projects';
  const target = isTexture || isProject ? '_self' : '_blank';
  let { roomTypeOptions } = useRoomTypeOptions();
  roomTypeOptions = [noneOption, ...roomTypeOptions];

  function canAccessImagineV2Model(){
    const orgPermissions = JSON.parse(
      localStorage.getItem('current_user')
    )?.organization_permissions_list;

    // console.log({orgPermissions})
    return orgPermissions?.find(per => per?.codename === PERMISSIONS.CAN_ACCESS_IMAGINE_V2_MODEL.codename)
  }

  const [searchParams, setSearchParams] = useSearchParams();
  const isInspirations = searchParams.get('sort') || undefined;

  /// need to implement these targets where necessary
  const pageSettings = {
    projects: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: [...roomTypeOptions, projectAutosaveFilter],
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    [CARD_TYPE.PRODUCT_CONFIGURATOR]: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: [noneOption, productConfigurator360, productConfigurator],
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    rooms: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: roomTypeOptions, //.filter(a => a.value !== ''),
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    templates: {
      sortOptions: isInspirations ? [inspirationSort, ...COMMON_SORT_OPTIONS_WITH_CREATED_AT] : COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: isInspirations ? inspirationSort : SortRecentFirstCreatedAt,
      subSortOptions: [createdFromAppFilter],
      filterOptions: canAccessLiveOnAppData() ? [...roomTypeOptions, createdFromApp] : roomTypeOptions, // NEED TO ADD Created From App
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    productSharePage: {
      sortOptions: isInspirations ? [inspirationSort, ...COMMON_SORT_OPTIONS_WITH_CREATED_AT] : COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: isInspirations ? inspirationSort : SortRecentFirstCreatedAt,
      subSortOptions: [createdFromAppFilter],
      filterOptions: canAccessLiveOnAppData() ? [...roomTypeOptions, createdFromApp] : roomTypeOptions, // NEED TO ADD Created From App
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    props: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: [],
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    products: {
      // for 3dmodels on my products page
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: [], // hide this
      clickUrl: `/products/my-models/product`,
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    model: {
      sortOptions: COMMON_SORT_OPTIONS,
      filterOptions: [], // hide this
      clickUrl: `/products/3dmodel/product`,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    textures: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: [],
      clickUrl: `/products/textures`,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    productroom: {
      sortOptions: COMMON_SORT_OPTIONS,
      filterOptions: roomTypeOptions,
      clickUrl: `/products/my-rooms/preview`,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    sharedFiles: {
      sortOptions: SHARED_FILES_SORT_OPTIONS,
      // sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: sharedFilesSortRecentFirst,
      // defaultSortOption: SortRecentFirst,
      filterOptions: SHARED_FILES_FILTER,
      clickUrl: `/products/my-rooms/preview`,
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
      showSharedFilter: true,
    },
    [`renders-previews`]: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      subSortOptions: [GroupedSort, UngroupedSort],
      filterOptions: [noneOption, rendersFilter, previewsFilter, uploadsFilter, archivedFilter],
      filterSubOptions: [archivedFilter],
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    uploads: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: SHARED_FILES_FILTER,
      clickUrl: '',
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    notifications: {
      sortOptions: NOTIFICATION_SORT_OPTIONS,
      defaultSortOption: NotificationSortRecentFirst,
      filterOptions: canAccessLiveOnApp() ? [...NOTIFICATION_FILTER_OPTIONS, nFilterLiveOnApp] : NOTIFICATION_FILTER_OPTIONS,
      clickUrl: ``, // to do
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    requests: {
      sortOptions: COMMON_SORT_OPTIONS,
      filterOptions: [
        allOptions,
        {label:threeDModelsLabel, value:threeDModelsValue},
        {label:creativeServiceLabel, value:creativeServiceValue , isDisabled:true},
        {label:customServiceLabel, value:customServiceValue , isDisabled:true},
        {label:SeamlessTextureLabel, value:SeamlessTextureValue , isDisabled:true},
        {label:Configurator_Label, value:RequestConfiguratorValue , isDisabled:true},
        {label:Video_Label, value:RequestVideoValue , isDisabled:true},

      ],
      clickUrl: ``, // to do
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    collections: {
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
      defaultSortOption: SortRecentFirst,
    },
    collection: {
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: COLLECTIONS_FILTER,
    },
    teams: {
      showTeamMemberFilter: false,
      showFavoriteIcon: false,
    },
    trash: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: [
        noneOption,
        trashProjectFilter,
        trashPreviewFilter,
        trashTextureFilter,
        trashCustomMapsFilter,
        trashUploadsFilter,
        trashCollectionFilter,
        trashAutomationFilter,
        trashConfiguratorFilter,
        trashImagineAIFilter,
      ],
      clickUrl: ``, // to do
      showTeamMemberFilter: true,
    },
    tutorials: {
      sortOptions: [],
      filterOptions: [],
    },
    tickets: {
      filterOptions: TICKET_FILTER_OPTIONS,
      showTeamMemberFilter: true,
      teamMemberFilterIconOnly: true,
    },
    automation: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: [...roomTypeOptions, projectAutosaveFilter],
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    configurators: {
      sortOptions: CONFIGURATOR_SORT_OPTIONS,
      defaultSortOption: SortRecentFirstCreatedAt,
    },
    ["automation-details"]: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: [{ label: 'Status', value: "" },
        { label: 'Disabled', value: RENDER_STATUS.STATUS_DISABLED },
        { label: 'Not Done', value: RENDER_STATUS.STATUS_NOT_DONE },
        { label: 'Done', value: RENDER_STATUS.STATUS_DONE },
        { label: 'Processing', value: RENDER_STATUS.STATUS_PROCESSING },
        { label: 'Failed', value: RENDER_STATUS.STATUS_FAILED }
      ],
      defaultFilterOption: { label: 'Status', value: "" },
    },

    attachments: {
      sortOptions: [
        {label:recentLable, value:recentValue},
        {label:nameLable, value:nameValue},
        {label:sizeLable, value:sizeValue},
        {label:kindLable, value:kindValue},
      ],
      filterOptions: [
        allOptions,
        {label:imagesLable, value:imagesValue},
        {label:threeDFilesLable, value:threeDFilesValue},
        {label:documentsLable, value:documentsValue},
      ],
    },
    lightroom: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: roomTypeOptions, //.filter(a => a.value !== ''),
      showFavoriteIcon: true,
      showTeamMemberFilter: false,
    },
    ['retail-automation']: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirst,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    [CARD_TYPE.ImagineAI]: {
      sortOptions: COMMON_SORT_OPTIONS_WITH_CREATED_AT,
      defaultSortOption: SortRecentFirstCreatedAt,
      filterOptions: [...ImagineAiFilterOption, ...(canAccessImagineV2Model() ? [ImagineV2Filter] : [])],
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    recentFiles: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: {
        value: Recent_First_Value,
        label: Recent_First_Label,
      },
      filterOptions: [allOptions, TextureFilterOption, ModelFilterOption, ProjectFilterOption],
      showFavoriteIcon: false,
      showTeamMemberFilter: false,
    },
    ['product-builder']: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
    materials: {
      sortOptions: COMMON_SORT_OPTIONS,
      defaultSortOption: SortRecentFirst,
      filterOptions: [],
      clickUrl: `/products/materials`,
      showFavoriteIcon: true,
      showTeamMemberFilter: true,
    },
  };
  return pageSettings[cardType];
};
